import { ScrollableList } from '@components'

import { ChangeEvent, useCallback, useMemo } from 'react'

import { useMultiplePayableSubjects } from '../../../../contexts'
import { SubjectsListItemContent } from './elements/SubjectsListItemContent'

export const SubjectsList = () => {
  const { subjects, saveSelectedSubjectAndSubjectId, selectedSubjectsIds, initialSubject } =
    useMultiplePayableSubjects()

  const subjectsFiltered = useMemo(
    () => subjects?.filter((bill) => bill.type === initialSubject?.type),
    [subjects, initialSubject?.type],
  )

  const handleCheckboxChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      saveSelectedSubjectAndSubjectId({
        currentSubjectId: event.currentTarget.value,
        isSelected: event.currentTarget.checked,
      })
    },
    [saveSelectedSubjectAndSubjectId],
  )

  return (
    <ScrollableList onChange={handleCheckboxChange} value={selectedSubjectsIds}>
      {subjectsFiltered?.map((bill) => {
        const billId = bill?.id
        const isInitialBill = billId === initialSubject?.id
        const isSelected = selectedSubjectsIds.includes(billId)

        return (
          <ScrollableList.Item id={billId} key={billId} disabled={isInitialBill} highlighted={isSelected}>
            <SubjectsListItemContent subject={bill} />
          </ScrollableList.Item>
        )
      })}
    </ScrollableList>
  )
}
